var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLetterOfCreditspng(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.834473,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#ECEFF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M29.2375 12.3345H18.7625C14.2125 12.3345 11.5 15.047 11.5 19.597V30.0595C11.5 34.622 14.2125 37.3345 18.7625 37.3345H29.225C33.775 37.3345 36.4875 34.622 36.4875 30.072V19.597C36.5 15.047 33.7875 12.3345 29.2375 12.3345Z",
    fill: "#667085"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6875 22.022H19.3125C18.8 22.022 18.375 21.597 18.375 21.0845C18.375 20.572 18.8 20.147 19.3125 20.147H28.6875C29.2 20.147 29.625 20.572 29.625 21.0845C29.625 21.597 29.2 22.022 28.6875 22.022Z",
    fill: "#667085"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6875 29.522H19.3125C18.8 29.522 18.375 29.097 18.375 28.5845C18.375 28.072 18.8 27.647 19.3125 27.647H28.6875C29.2 27.647 29.625 28.072 29.625 28.5845C29.625 29.097 29.2 29.522 28.6875 29.522Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterOfCreditspng);
export default __webpack_public_path__ + "static/media/letter_of_creditspng.aea0a17d8472cdd317c5f656eb53a835.svg";
export { ForwardRef as ReactComponent };